"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBMNLive1Schema = void 0;
exports.RBMNLive1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/rbmn-live/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "RBMNLive1",
    "description": "RBMN Live Stream Asset",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:rbmn-live:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "assetId": {
                    "type": "string",
                    "description": "Asset ID from mediabase Media Network Content Hub asset catalogue (e.g. AA-1UPS7JDND1W12)",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "mbEnvironment": {
                    "type": "string",
                    "description": "On which mediabase environment is the asset available (if not set, production is assumed)",
                    "enum": [
                        "production",
                        "staging"
                    ]
                },
                "VIN": {
                    "type": "string",
                    "description": "Video identification number from mediabase Media Network Content Hub catalogue (e.g. MI201802070142)",
                    "pattern": "^MI[0-9]+$"
                }
            },
            "required": [
                "assetId",
                "VIN"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yYm1uLWxpdmUvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxlQUFlLEdBQUc7SUFDN0IsS0FBSyxFQUFFLDhFQUE4RTtJQUNyRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxXQUFXO0lBQ3BCLGFBQWEsRUFBRSx3QkFBd0I7SUFDdkMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHNDQUFzQzthQUN2QztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsMkZBQTJGO29CQUMxRyxTQUFTLEVBQUUsbURBQW1EO2lCQUMvRDtnQkFDRCxlQUFlLEVBQUU7b0JBQ2YsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSwyRkFBMkY7b0JBQzFHLE1BQU0sRUFBRTt3QkFDTixZQUFZO3dCQUNaLFNBQVM7cUJBQ1Y7aUJBQ0Y7Z0JBQ0QsS0FBSyxFQUFFO29CQUNMLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsc0dBQXNHO29CQUNySCxTQUFTLEVBQUUsWUFBWTtpQkFDeEI7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixTQUFTO2dCQUNULEtBQUs7YUFDTjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9